import(/* webpackMode: "eager" */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\app\\global-error.jsx");
